import React from "react";
import { Field } from "react-final-form";
import RffInputWrapper from "../shared/RffInputWrapper";
import DollarInput from "../../inputs/DollarInput";

const RffDollarField = ({
  name,
  label,
  required = false,
  helperText,
  hint,
  optional = false,
  placeholder,
  fullWidth = true,
  row = false,
  suppressGrid,
  size,
  disabled,
  onBlur,
}) => (
  <RffInputWrapper
    label={label}
    suppressGrid={suppressGrid}
    size={size}
    helperText={helperText}
    hint={hint}
    optional={optional}
    required={required}
    row={row}
  >
    <Field
      name={name}
      validate={(v) =>
        required && (v == null || v === "") ? "This field is required" : undefined
      }
      parse={(v) => (v === "" ? undefined : v)}
      render={({ input, meta }) => (
        <DollarInput
          {...input}
          onBlur={onBlur}
          placeholder={placeholder}
          disabled={disabled}
          fullWidth={fullWidth}
          error={meta.touched && !!meta.error}
          helperText={meta.touched && meta.error ? meta.error : null}
        />
      )}
    />
  </RffInputWrapper>
);

export default RffDollarField;
